import { Component, Vue } from 'vue-property-decorator'
import { querySummary, createClass, queryCourse, queryCourseB, deleteClass, editClass, querymyCourseType, editCourseCode } from '@/api'
import HighFilter from '@/components/highFilter/index.vue'
@Component({ name: 'class-management-page', components: { HighFilter } })
export default class ClassManagementPage extends Vue {
  private tableAll: any = {}
  private tableData = []
  private courseList: any = []
  private totalPage = 1;
  private currentPage = 1;
  private addDialogShow = false
  private filterData: any = {};
  private filterResult: any = null
  private showHighFilter = false
  private tableloading: any = false
  private courseTypeList: any = []
  private courseListLoading: any=false
  private addClassObj: any = {
    className: null,
    courseType: null,
    schoolBegins: null,
    courseId: null,
    courseName: null
  }

  created () {
    this.initPageData()
    this.myCourseType()
  }

  get inclass () {
    return this.getinclass()
  }

  getinclass () {
    return this.tableData.filter((item: any) => { return item.status === 2 })
  }

  private async initPageData () {
    this.tableloading = true
    const list: any = [{ path: '/class/edit/courseCode', pathName: 'editCourseCode' }]

    const param: any = { page: this.currentPage, limit: 20 }
    if (this.filterResult) {
      param.searchObejct = this.filterResult
    }
    param.pathList = list

    const result: any = await querySummary(param)
    this.tableAll = result
    this.totalPage = result.allPage
    this.currentPage = result.currentPage
    this.tableData = result.classList
    this.filterData = result.search
    this.tableloading = false
  }

  private async myCourseType () {
    const data = await querymyCourseType({})
    this.courseTypeList = data
  }

  private async querySearchAsync (queryString: any, cb: Function) {
    console.log('queryString: ', queryString)
    this.addClassObj.courseId = null
    if (!queryString) {
      const sl: never[] = []
      cb(sl)
      return
    }
    console.log('this.addClassObj: ', this.addClassObj)
    this.courseList = null
    this.courseList = await queryCourseB({
      courseType: !this.addClassObj.courseType || this.addClassObj.courseType === ''
        ? null : this.addClassObj.courseType * 1,
      schoolBegins: this.addClassObj.schoolBegins,
      name: queryString
    })

    console.log('response: ', typeof this.courseList)
    if (!this.courseList || this.courseList.length < 0) {
      return
    }

    const select = this.courseList.map((item: any) => {
      return { value: `${item.schoolBegins} ${item.name}`, id: item.id }
    })
    cb(select)
  }

  private async handleSelect (item: any) {
    console.log('handleSelect item: ', item)
    this.addClassObj.courseId = item.id
  }

  private async changeTimeval () {
    console.log('addClassObj.courseName: ', this.addClassObj.courseName)
    console.log('addClassObj.courseId: ', this.addClassObj.courseId)
    this.addClassObj.courseId = null
    this.courseList = await queryCourse({
      courseType: this.addClassObj.courseType,
      schoolBeginsChangeCourse: this.addClassObj.schoolBegins
    })
  }

  /**
  * [description] 分页切换回调函数
  */
  private async onPageChange () {
    this.initPageData()
  }

  statusFilter (status: any) {
    const statusStr = ['', '未上课', '上课中', '异常中', '即将结课']
    return statusStr[status]
  }

  private async changeCourseCode (item: any) {
    await editCourseCode({ classId: item.classId, courseCode: item.courseCode })
    this.$message({ message: '修改Course Code成功', type: 'success' })
    // await this.initPageData()
  }

  private async editClassClick (data: any) {
    await editClass({ classId: data.classId, newClassName: data.className })
    this.$message({ message: '修改名称成功', type: 'success' })
  }

  private async deteleClassClick (data: any) {
    this.$confirm('确认删除' + '“' + data.className + '”班吗?', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'error',
      center: true
    }).then(async () => {
      this.$message({
        type: 'success',
        message: '删除成功!'
      })
      await deleteClass({ classId: data.classId })
      this.initPageData()
    })
  }

  private async onSetClick () {
    if (!this.addClassObj.courseId) {
      this.$message({ message: '请选择具体项目', type: 'error' })
      return
    }
    if (!this.addClassObj.className) {
      this.$message({ message: '请输入具体班级名', type: 'error' })
      return
    }
    await createClass({ className: this.addClassObj.className, courseId: this.addClassObj.courseId })
    this.initPageData()
    this.addDialogShow = false
    this.$message({ message: '创建班级成功', type: 'success' })
    this.reset()
  }

  private async reset () {
    this.addClassObj = {
      className: null,
      courseType: null,
      schoolBegins: null,
      courseId: null
    }
  }

  private async rowClicked (row: any, column: any) {
    if (['班级名称', 'Course Code'].indexOf(column.label) === -1) {
      this.$router.push({ path: '/student/class_managementStudent', query: { id: row.classId, className: row.className } })
    }
  }

  private async onFilterResult (data: any) {
    this.filterResult = data
    this.currentPage = 1
    await this.initPageData()
    this.showHighFilter = false
  }
}
